var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"articles-detail"},[_c('h1',[_vm._v("Welcome to CDS Flight Deck Help Articles! Choose a subject on the left to begin or search for a topic above.")])])
}]

export { render, staticRenderFns }